import React, { PureComponent, Fragment } from 'react'

// local components
import WeedmapPinItem from './WeedmapPinItem'
import EditableHOCWrapper from '../../containers/HOC/EditableHOC'
import { Appcues } from '../../utils/constants'

const WeedmapPinItemEditable = EditableHOCWrapper(WeedmapPinItem)

class WeedmapPinItemContainer extends PureComponent {
  onSave = (data, afterOnSave) => {
    Appcues.track('Weedmap PIN Saved')
    this.props.onPinUpdate(data, afterOnSave)
  }

  onChangeSync = (data, afterOnSave) => {
    this.props.onPinUpdate(data, afterOnSave)
  }

  render() {
    const {
      pin = {},
      lastModified = null,
      onCancel,
      onDelete,
      defaultEditMode,
      regions = [],
      version = 1,
      authorizeWeedmapToken,
      renewWeedmapToken,
      weedmapsOrders = {},
    } = this.props

    return (
      <Fragment>
        {version === 1 ? (
          <WeedmapPinItemEditable
            dataToEdit={pin}
            onSave={this.onSave}
            lastModified={lastModified}
            onCancel={onCancel}
            onDelete={onDelete}
            defaultEditMode={defaultEditMode}
            regions={regions}
            version={version}
            weedmapsOrders={weedmapsOrders}
            authorizeWeedmapToken={authorizeWeedmapToken}
            renewWeedmapToken={renewWeedmapToken}
            onChangeSync={this.onChangeSync}
          />
        ) : null}
        {version === 2 || version === 3 ? (
          <WeedmapPinItemEditable
            dataToEdit={pin}
            onSave={this.onSave}
            lastModified={lastModified}
            onCancel={onCancel}
            onDelete={onDelete}
            defaultEditMode={defaultEditMode}
            regions={regions}
            version={version}
            weedmapsOrders={weedmapsOrders}
            authorizeWeedmapToken={authorizeWeedmapToken}
            renewWeedmapToken={renewWeedmapToken}
            onChangeSync={this.onChangeSync}
          />
        ) : null}
      </Fragment>
    )
  }
}

export default WeedmapPinItemContainer



// WEBPACK FOOTER //
// ./src/components/WeedmapInfo/WeedmapPinItemContainer.js